import TransactionPaymentRow from './TransactionPaymentRow';

export default TransactionPaymentRow;
